"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OnlineColorMatchingToolCta() {
  // 使用捲動偵測機制
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={sectionRef} id="線上配色套圖-cta" className="w-full overflow-hidden bg-[#e8e2dc]">
      <div className={cn("w-full transition-all duration-[1200ms] ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6")}>
        {/* 滿版大圖容器 */}
        <div className="relative w-full h-[450px] sm:h-[520px] md:h-[580px] lg:h-[650px] bg-[#e8e2dc]">
          
          {/* 背景大圖 */}
          <img src="https://hent.services/wp-content/uploads/2026/05/Flooring_Bottom.webp" alt="選一個讓你想回家的顏色 - 亨特地板" className="absolute inset-0 w-full h-full object-cover object-center pointer-events-none" />

          {/* 內容疊加層 */}
          <div className="absolute inset-0 z-20 flex items-center select-none">
            {/* 響應式容器：控制主軸左邊距 */}
            <div className="container mx-auto px-8 sm:px-14 md:px-20 lg:px-24 w-full">
              
              {/* 左側 Lifestyle 排版區塊 */}
              <div className="flex flex-col items-start text-left max-w-xl space-y-6 md:space-y-8">
                
                {/* 標題與裝飾線組 */}
                <div className="space-y-4">
                  {/* 字型顏色修正為 #56493f，字重採用 Noto Sans HK Regular (font-normal) */}
                  <h2 className="font-hk-regular text-2xl sm:text-3xl md:text-4xl font-normal text-[#56493f] tracking-widest leading-tight">
                    選一個讓你想回家的顏色
                  </h2>
                  {/* 依圖還原的精緻裝飾短線 */}
                  <div className="w-16 h-[1px] bg-[#56493f]/30 mt-2" />
                </div>
                
                {/* 內文描述組 */}
                {/* 字型顏色修正為 #56493f，字重採用 Noto Sans HK Thin (font-light/font-thin) */}
                <div className="space-y-4 font-hk-light text-sm sm:text-base md:text-[17px] text-[#56493f] font-light leading-relaxed tracking-widest">
                  <p>
                    上傳空間照片，或從情境範例中挑選喜歡的風格，
                    <br className="hidden sm:block" />
                    看看不同花色與光線交織後的模樣。
                  </p>
                  <p>在一次次的搭配裡，找到最接近理想生活的顏色。</p>
                </div>

                {/* 按鈕組 */}
                {/* 按鈕背景色為原本設計的深木色，文字則採用 Noto Sans TC SemiBold 搭配純白 (#ffffff) */}
                <a href="https://pim-client.wizart.ai/fitting-room?api_token=3DbIXLfXHxV5t845ztHFBmsXU92FacZQAwh5pKO4axfHSXDef6365nmWv129&bba=true" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-3 bg-[#544741] hover:bg-[#433833] text-[#ffffff] text-xs sm:text-sm font-sans font-semibold tracking-widest px-6 py-3 sm:px-8 sm:py-3.5 shadow-md hover:shadow-lg transition-all duration-300">
                  <span>開始搭配空間</span>
                  <ArrowRight className="size-3.5 sm:size-4 transition-transform duration-300 group-hover:translate-x-1.5" />
                </a>

              </div>

            </div>
          </div>

        </div>
      </div>
    </section>;
}